import _Message from "@mui/icons-material/Message";
import React from 'react';
import { COLORS } from '@fupa/fupa-uikit';
import { Heading, IconContainer, LinkContainer, LinkText, StyledLink, Subtitle, Title, Wrapper } from 'app/components/styles/districtModules/headerStyles';
export default function TopNewsHeader(_ref) {
  let {
    pathname
  } = _ref;
  return /*#__PURE__*/React.createElement(Wrapper, {
    "data-sentry-element": "Wrapper",
    "data-sentry-component": "TopNewsHeader",
    "data-sentry-source-file": "TopNewsHeader.tsx"
  }, /*#__PURE__*/React.createElement(IconContainer, {
    color: COLORS.darkGreen,
    "data-sentry-element": "IconContainer",
    "data-sentry-source-file": "TopNewsHeader.tsx"
  }, /*#__PURE__*/React.createElement(_Message, {
    style: {
      color: COLORS.white,
      fontSize: 'inherit'
    },
    "data-sentry-element": "Message",
    "data-sentry-source-file": "TopNewsHeader.tsx"
  })), /*#__PURE__*/React.createElement(Heading, {
    "data-sentry-element": "Heading",
    "data-sentry-source-file": "TopNewsHeader.tsx"
  }, /*#__PURE__*/React.createElement(Title, {
    variant: "subheading2",
    component: "span",
    "data-sentry-element": "Title",
    "data-sentry-source-file": "TopNewsHeader.tsx"
  }, "Top-Meldungen"), /*#__PURE__*/React.createElement(Subtitle, {
    variant: "caption3",
    "data-sentry-element": "Subtitle",
    "data-sentry-source-file": "TopNewsHeader.tsx"
  }, "Alles Wichtige auf einen Blick")), pathname ? /*#__PURE__*/React.createElement(LinkContainer, null, /*#__PURE__*/React.createElement(StyledLink, {
    to: "".concat(pathname, "/news"),
    decoration: "underline"
  }, /*#__PURE__*/React.createElement(LinkText, {
    variant: "caption3"
  }, 'Alle Meldungen >'))) : null);
}